<template>
  <div>
    <div style="height: 550px;">
      <el-table :data="applyList" stripe max-height="400" style="width: 90%;height: 550px;margin: 0px auto;">
        <el-table-column prop="type" label="类型"> </el-table-column>
        <el-table-column prop="title" label="名称" width="300"></el-table-column>
        <el-table-column prop="addtime" label="发布时间"> </el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button link type="primary" size="mini" @click="gotoDetail(scope.row.id, scope.row.type)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="
                width: 90%;
                margin: 20px auto;
                display: flex;
                align-items: center;
                justify-content: space-between;
                text-align: left;
              ">
      <el-pagination background layout="prev, pager, next" :pageSize="pageSize" :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/api/request";
export default {
  name: "myApply",
  data() {
    return {
      dialogVisible: false,
      rating: 0,
      comment: "",
      applyList: [],
      pageSize: 5,
      total: null,
      hideOnSinglePage: true,
      id: null,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    indexMethod(index) {
      return index + 1;
    },
    initData(pageindex) {
      request
        .post("/api/Policy/GetAllcollection", {
          pagesize: this.pageSize,
          pageindex: pageindex,
        })
        .then((response) => {
          // console.log(response)
          // 请求成功时处理数据
          if (response.data.Data && response.data.Data.data) {
            this.applyList = [...response.data.Data.data];
            this.total = response.data.Data.total;
            // this.formateList();
            // console.log(this.applyList);
          }
        })
        .catch((error) => {
          // 请求失败时的处理
          console.error("Error fetching data:", error);
        });
    },
    gotoDetail(id, type) {
      if (type == "政策检索") {
        this.$router.push("/PolicyCalculation/PolicyDetails/" + id);
      } else if (type == "政策解读") {
        this.$router.push("/PolicyCalculation/policyInterpretationDeteils/" + id);
      } else if (type == "活动") {
        this.$router.push({
        path: "/activityInfo",
        query: {
          id: id,
        },
      });
      } else if (type == "项目") {
        this.$router.push('/PolicyCalculation/policySearchDetail/' + id);
      }
    },
    formateList() {
      var index = 0;
      this.applyList.forEach((apply) => {
        apply["time"] =
          apply.begin_time.replace(/[a-zA-Z]/g, " ") +
          "~" +
          apply.end_time.replace(/[a-zA-Z]/g, " ");
      });
    },
    // 当当前页发生变化时的回调
    handleCurrentChange(val) {
      this.initData(val); // 重新查询数据
    },
  },
};
</script>